"use client"

import React, { useCallback, useState } from "react"
import styled from "styled-components"
import { Label } from "@jobintrans/base-ui.components.atoms.typography"
import { Box, Row } from "@jobintrans/base-ui.components.atoms._atoms"
import { BaseStyles } from "@jobintrans/base-ui.types.base-styles"
import Checkbox from "@jobintrans/base-ui.components.atoms.checkbox"
import { IconButton } from "@jobintrans/base-ui.components.atoms.button"

export type DropdownCheckboxesProps = BaseStyles & {
  name: string[]
  $type?: "primary" | "secondary"
  value: any[][]
  options: any[]
  label?: string
  labelIcon?: string
  onChange?: (e: object) => void
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const DropdownCheckboxesGroup = ({
  name: headName = [],
  $type = "primary",
  value: headValue = [],
  options = [],
  label,
  labelIcon,
  onChange = () => {},
  ...rest
}: DropdownCheckboxesProps) => {
  const [show, setShow] = useState<number | null>(0)

  const handleClickParent = useCallback(
    ({ name, value }: { name: string; value: boolean }) => {
      let arr: any = []
      if (value) {
        arr = [name]
      } else {
        arr = headValue[0].filter(e => e !== name)
      }

      onChange({
        [headName[0]]: arr,
        [headName[1]]: [],
      })
    },
    [onChange, headValue, options],
  )

  const handleClickChild = useCallback(
    (
      parentName: string,
      parentChildren: string[],
      child: {
        name: string
        value: boolean
      },
    ) => {
      const { name: childName, value } = child
      let parentArr: any = [headValue[0]]
      let childArr: any = [headValue[1]]

      if (value) {
        parentArr = [parentName]
        childArr = [childName]
        headValue[1].forEach(v => {
          if (parentChildren.map(e => e[1]).includes(v)) {
            childArr.push(v)
          }
        })
      } else {
        childArr = headValue[1].filter(e => e !== childName)
      }

      onChange({
        [headName[0]]: parentArr,
        [headName[1]]: childArr,
      })
    },
    [onChange, headValue, options],
  )

  return (
    <Wrapper {...rest}>
      {label && (
        <Label icon={labelIcon} $marginBottom="S">
          {label}
        </Label>
      )}
      <Content>
        {options.map((el: string[], index) => {
          if (!el[2]) {
            return (
              <Checkbox
                key={`${el[1]}`}
                $type={$type}
                name={`${el[1]}`}
                value={headValue[0]?.includes(el[1])}
                onChange={it => handleClickParent(it)}
                label={`${el[0]}`}
              />
            )
          } else {
            const showChildren = show === index || headValue[0]?.includes(el[1])
            return (
              <Box key={`${el[1]}`}>
                <>
                  <Row $justifyContent="space-between" $alignItems="center">
                    <Checkbox
                      $type={$type}
                      name={`${el[1]}`}
                      value={headValue[0]?.includes(el[1])}
                      onChange={it => handleClickParent(it)}
                      label={`${el[0]}`}
                    />
                    <IconButton
                      icon={showChildren ? "arrow-top" : "arrow-bottom"}
                      ariaLabel="Close"
                      onClick={() => setShow(show === index ? null : index)}
                    />
                  </Row>
                  {showChildren && (
                    <ChildContent $marginTop="XS" $paddingLeft="S">
                      {Array.isArray(el[2]) &&
                        el[2].map((subitem: any) => (
                          <Checkbox
                            key={`${subitem[1]}`}
                            $type={$type}
                            name={`${subitem[1]}`}
                            value={
                              (headValue[0]?.includes(el[1]) && headValue[1].length === 0) ||
                              (headValue[0]?.includes(el[1]) && headValue[1]?.includes(subitem[1]))
                            }
                            // @ts-ignore
                            onChange={it => handleClickChild(el[1], el[2], it)}
                            label={`${subitem[0]}`}
                          />
                        ))}
                    </ChildContent>
                  )}
                </>
              </Box>
            )
          }
        })}
      </Content>
    </Wrapper>
  )
}

const ChildContent = styled(Box)`
  display: grid;
  grid-gap: ${({ theme }) => theme.space.XS};
`

const Content = styled(Box)`
  display: grid;
  grid-gap: ${({ theme }) => theme.space.S};
`

const Wrapper = styled(Box)`
  * {
    box-sizing: border-box;
  }
`
